import React, { useState, useEffect } from 'react';

const Hero: React.FC = () => {
  const heroImages = [
    '/images/save-the-date/007-savethedate.jpg',
    '/images/save-the-date/056-savethedate.jpg',
    '/images/save-the-date/010-savethedate.jpg',
    '/images/save-the-date/001-savethedate.jpg',
    '/images/save-the-date/010-savethedate.jpg',
    '/images/save-the-date/020-savethedate.jpg',
    '/images/save-the-date/040-savethedate.jpg',
    '/images/save-the-date/040-savethedate.jpg',
    '/images/save-the-date/063-savethedate.jpg',
    '/images/save-the-date/060-savethedate.jpg',
    '/images/save-the-date/070-savethedate.jpg',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <section
      id="hero"
      className="relative h-screen flex items-end justify-center overflow-hidden pb-32"
    >
      {/* Crossfading background images */}
      {heroImages.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-[3000ms] ease-in-out"
          style={{
            backgroundImage: `url(${image})`,
            opacity: currentImageIndex === index ? 1 : 0,
            willChange: 'opacity',
          }}
        />
      ))}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      <div className="relative z-10 text-center text-white px-4 md:px-6">
        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl mb-3 md:mb-4 animate-fade-in">
          Nelisa & Jesse
        </h1>
        <div className="w-16 sm:w-20 md:w-24 h-px bg-wedding-gold mx-auto mb-3 md:mb-4"></div>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-4 md:mb-8 tracking-wide sm:tracking-widest">
          Are Tying the Knot
        </p>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl font-light">
          June 26, 2027
        </p>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl font-light mb-6 md:mb-8">
          Punta Cana, Dominican Republic
        </p>

        <button
          onClick={() => {
            document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="bg-wedding-gold text-wedding-navy px-6 py-2 sm:px-8 sm:py-3 rounded-full text-sm sm:text-base font-semibold hover:bg-opacity-90 transition-all transform hover:scale-105"
        >
          RSVP Now
        </button>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
